module.exports = __webpack_public_path__ + "prod/1.42.2/img/service-1.b166bcf6.png";